import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { PersistentNavigationComponent } from './persistent-navigation.component';

@NgModule({
	declarations: [PersistentNavigationComponent],
	imports: [CommonModule, RouterModule, DzIconModule.withIcons(faChevronDown, faChevronUp), CwpNgFrameworkModule],
	exports: [PersistentNavigationComponent]
})
export class PersistentNavigationModule { }
